

  // Full Shopify JavaScript for Wishlist functionality (assets/wishlist.js)

// Initialize wishlist from localStorage if customer is not logged in
let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

// Function to add product to local wishlist and handle logged-in users
function addWishlistProduct(productHandle) {
  console.log(
    "addWishlistProduct function started with productHandle:",
    productHandle
  );

  if (!wishlist.includes(productHandle)) {
    wishlist.push(productHandle);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    

    if (window.customerId && window.customerId !== "null") {
      updateWishlistButtonStateLoggedIn(productHandle); // Update button state for logged-in users
    } else {
      updateWishlistButtonState(productHandle); // Update button state for logged-out users
    }

    
    updateWishlistCountFrontend(1); // Increment the count immediately for front-end

    // Send wishlist add event to GA4
    gtag('event', 'add_to_wishlist', {
      item_name: productHandle,
      currency: Shopify.currency.active
    });

    
  } else {
    // Product is already in wishlist, do nothing here
    return;
  }

  // Check if the customer is logged in using window.customerId
  console.log("Attempting customer check:", window.customerId);
  if (window.customerId && window.customerId !== "null") {
    console.log(
      "Customer is logged in. Adding product to wishlist for customerId:",
      window.customerId
    );
    addToWishlistBackend(window.customerId, productHandle);
  } else {
    console.warn("Customer is not logged in, adding product to local storage.");
    // Product already added to local wishlist above
  }
}

// Function to remove product from wishlist
// Function to remove product from wishlist
function removeFromWishlist(productHandle) {
  const index = wishlist.indexOf(productHandle);
  if (index > -1) {
    wishlist.splice(index, 1);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    
    if (window.customerId && window.customerId !== "null") {
      updateWishlistButtonStateLoggedIn(productHandle); // Update button state for logged-in users
    } else {
      updateWishlistButtonState(productHandle); // Update button state for logged-out users
    }
    
    updateWishlistCountFrontend(-1); // Decrement the count immediately for front-end

    // Remove the item from the wishlist page list if it exists
    const wishlistItemElement = document.querySelector(`.wishlist-item[data-product-handle="${productHandle}"]`);
    if (wishlistItemElement) {
      console.log("wishlistItemElement: ", wishlistItemElement);
      wishlistItemElement.style.display = 'none'; // Hide the item immediately
    }

    // NEW: Remove the server-rendered product card for logged-in users
    if (window.customerId && window.customerId !== "null") {
      const serverRenderedWishlistItem = document.querySelector(`.wishlist-page-wrapper .gs-collection-card-wrapper.gs-${productHandle}`);
      if (serverRenderedWishlistItem) {
          console.log("wishlistItemElement Logged In: ", serverRenderedWishlistItem);
        serverRenderedWishlistItem.style.display = 'none'; // Hide the server-rendered product card
      }
    }

    // Send wishlist remove event to GA4
    gtag('event', 'remove_from_wishlist', {
      item_name: productHandle,
      currency: Shopify.currency.active
    });
  }

  // Check if customer is logged in
  if (window.customerId && window.customerId !== "null") {
    console.log(
      "Customer is logged in. Removing product from wishlist for customerId:",
      window.customerId
    );
    removeFromWishlistBackend(window.customerId, productHandle);
  }
}


// Function to render wishlist items on the page
function renderWishlistItems(productHandles) {
  const wishlistContainer = document.getElementById("wishlist-items");
  if (!wishlistContainer) {
    console.error("Error: Could not find wishlist container on the page.");
    return;
  }

  if (productHandles.length === 0) {
    wishlistContainer.innerHTML = "<p>Your wishlist is empty.</p>";
  } else {
    wishlistContainer.innerHTML = "";
    productHandles.forEach((productHandle) => {
      console.log("Fetching details for product handle:", productHandle);

      // Fetch product details using Ajax API
      fetch(`/products/${productHandle.trim()}.js`)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Product not found");
          }
          return response.json();
        })
        .then((product) => {
          console.log("Fetched product details:", product);
          const formattedPrice = (product.price / 100).toLocaleString(undefined, { style: 'currency', currency: Shopify.currency.active });
          const formattedCompareAtPrice = product.compare_at_price ? (product.compare_at_price / 100).toLocaleString(undefined, { style: 'currency', currency: Shopify.currency.active }) : '';
          let variantsOptionsHtml = '';
          let selectedVariantId = product.variants && product.variants.length > 0 ? product.variants[0].id : null;
          if (product.variants && product.variants.length > 0) {
              variantsOptionsHtml = '<div class="variant-options" style="display: none;">';
              product.variants.forEach(variant => {
                   const opacityStyle = variant.available ? '' : 'opacity: 0.5; pointer-events: none;';
                  variantsOptionsHtml += `<button type="button" class="variant-option" data-variant-id="${variant.id}" style="${opacityStyle}">${variant.title}</button>`;
              });
              variantsOptionsHtml += '</div>';
          }

           // Create wishlist item element
  const wishlistItem = document.createElement('div');
  wishlistItem.classList.add('wishlist-item');
  wishlistItem.setAttribute('data-product-handle', product.handle);

  wishlistItem.innerHTML = `
    <a class="wishlist-link-gs" href="/products/${product.handle}">
      <img src="${product.images[0]}" alt="${product.title}" />
      <div class="product-title-wish">${product.title}</div>
      <div class="price">
        ${product.price ? `<span class="price-item">${formattedPrice}</span>` : ''}
        ${product.compare_at_price > product.price ? `<s class="compare-price">${formattedCompareAtPrice}</s>` : ''}
      </div>
    </a>

    ${product.variants && product.variants.length > 1 ? `
      <div class="variant-selector">
        ${variantsOptionsHtml}
      </div>
    ` : ''}

    <div class="quick-add no-js-hidden">
      ${product.variants && product.variants.length > 1 ? `
        <button type="button" class="select-size button button--secondary">Select Size</button>
        <button type="button" class="quick-add__submit button button--secondary" style="display: none;" ${selectedVariantId && product.variants[0].available ? '' : 'disabled'}>
          ${selectedVariantId && product.variants[0].available ? 'Add to Cart' : 'Sold Out'}
        </button>
      ` : `
        <button type="button" class="quick-add__submit button button--secondary" ${product.variants[0].available ? '' : 'disabled'}>
          ${product.variants[0].available ? 'Add to Cart' : 'Sold Out'}
        </button>
      `}
    </div>

    <button class="remove-from-wishlist">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <title>Close</title>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Close">
            <rect id="Rectangle" fill-rule="nonzero" x="0" y="0" width="24" height="24"></rect>
            <line x1="16.9999" y1="7" x2="7.00001" y2="16.9999" id="Path" stroke="#0C0310" stroke-width="2" stroke-linecap="round"></line>
            <line x1="7.00006" y1="7" x2="17" y2="16.9999" id="Path" stroke="#0C0310" stroke-width="2" stroke-linecap="round"></line>
          </g>
        </g>
      </svg>
    </button>
  `;

  // Add event listener to "Select Size" button if variants exist
  if (product.variants && product.variants.length > 1) {
    const selectSizeButton = wishlistItem.querySelector('.select-size');
    selectSizeButton.addEventListener('click', () => {
      const variantSelector = wishlistItem.querySelector('.variant-options');
      const addToCartButton = wishlistItem.querySelector('.quick-add__submit');
      variantSelector.style.display = 'flex';
      addToCartButton.style.display = 'block';
      selectSizeButton.style.display = 'none';
    });
  }

          // Add event listener to each variant button
          const variantButtons = wishlistItem.querySelectorAll('.variant-option');
          variantButtons.forEach(button => {
              button.addEventListener('click', () => {
                  variantButtons.forEach(btn => btn.classList.remove('selected'));
                  button.classList.add('selected');
                  selectedVariantId = button.getAttribute('data-variant-id');
              });
          });

          // Add event listener to "Add to Cart" button
          const addToCartButton = wishlistItem.querySelector('.quick-add__submit');
          addToCartButton.addEventListener('click', () => {
              if (selectedVariantId) {
                  // Create a form dynamically to submit the item to the cart
                  const form = document.createElement('form');
                  form.method = 'post';
                  form.action = '/cart/add';
                  form.style.display = 'none';

                  const input = document.createElement('input');
                  input.type = 'hidden';
                  input.name = 'id';
                  input.value = selectedVariantId;

                  form.appendChild(input);
                  document.body.appendChild(form);
                  form.submit();
              } else {
                  console.error("No variant selected");
              }
          });

          // Add event listener to "Remove" button
          const removeButton = wishlistItem.querySelector('.remove-from-wishlist');
          removeButton.addEventListener('click', (event) => {
              event.stopPropagation(); // Prevent event bubbling
              removeFromWishlist(product.handle);
              // updateWishlistCountFrontend(-1); // Update wishlist count immediately for front-end
          });

          wishlistContainer.appendChild(wishlistItem);
      })
      .catch((error) => {
          console.error("Failed to fetch product details:", error);
      });
    });
  }
}

// Event listener for adding/removing product to/from wishlist
document.addEventListener("DOMContentLoaded", () => {
  const addToWishlistButtons = document.querySelectorAll(
    ".add-to-wishlist-button"
  );
  addToWishlistButtons.forEach((button) => {
    const productHandle = button.getAttribute("data-product-handle");
    if (productHandle && wishlist.includes(productHandle)) {
      button.classList.add("active-wishlist");
    }
    button.addEventListener("click", (event) => {
      event.stopPropagation(); // Prevent event bubbling
      if (productHandle) {
        if (wishlist.includes(productHandle)) {
          // Product is already in wishlist, remove it
          removeFromWishlist(productHandle);
        } else {
          // Product is not in wishlist, add it
          addWishlistProduct(productHandle);
        }
      } else {
        console.error("Error: productHandle is not defined or null.");
      }
    });
  });

  // Render wishlist items if on wishlist page
  const wishlistContainer = document.getElementById("wishlist-items");
  if (wishlistContainer) {
    console.log("Wishlist container found. Rendering wishlist items...");
    if (window.customerWishlist) {
      if (Array.isArray(window.customerWishlist)) {
        console.log("Customer wishlist is an array:", window.customerWishlist);
        renderWishlistItems(window.customerWishlist);
      } else {
        console.error(
          "Unexpected format for customerWishlist:",
          window.customerWishlist
        );
        renderEmptyWishlist();
      }
    } else {
      console.log("No customerWishlist found. Rendering local wishlist.");
      if (wishlist.length === 0) {
        renderEmptyWishlist();
      } else {
        renderWishlistItems(wishlist);
      }
    }
  }

  // Update wishlist count on page load
  updateWishlistCount();
});

// Function to render empty wishlist message
function renderEmptyWishlist() {
  const wishlistContainer = document.getElementById("wishlist-items");
  if (!wishlistContainer) {
    console.error("Error: Could not find wishlist container on the page.");
    return;
  }
  wishlistContainer.innerHTML = "<p>Your wishlist is empty.</p>";
}

// Function to add product to wishlist by sending data to backend (Google Cloud Function)
function addToWishlistBackend(customerId, productHandle) {
  const url =
    "https://us-central1-shopify-wishlist-backend.cloudfunctions.net/addToWishlist-DARKAI";
  console.log("Sending request to backend with customerId and productHandle:", {
    customerId,
    productHandle,
  });

  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ customerId, productHandle }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Wishlist updated on backend:", data);
    })
    .catch((error) => {
      console.error("Failed to update wishlist on backend:", error);
    });
}

// Function to remove product from wishlist by sending data to backend (Google Cloud Function)
function removeFromWishlistBackend(customerId, productHandle) {
  const url =
    "https://us-central1-shopify-wishlist-backend.cloudfunctions.net/removeFromWishlist-Andrea-DARKAI";
  console.log(
    "Sending request to backend to remove product with customerId and productHandle:",
    { customerId, productHandle }
  );

  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ customerId, productHandle }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Wishlist updated on backend after removal:", data);
    })
    .catch((error) => {
      console.error(
        "Failed to update wishlist on backend after removal:",
        error
      );
    });
}

// Function to update the wishlist count in the header immediately for the front-end
function updateWishlistCountFrontend(change) {
  const wishlistCountElement = document.getElementById("wishlist-count");
  if (!wishlistCountElement) {
    console.error("Error: Could not find wishlist count element on the page.");
    return;
  }
  const currentCount = parseInt(wishlistCountElement.textContent) || 0;
  const newCount = currentCount + change;
  wishlistCountElement.textContent = newCount > 0 ? newCount : "";
  wishlistCountElement.style.display = newCount > 0 ? "inline" : "none";
}

// Function to update the wishlist count in the header
function updateWishlistCount() {
  const wishlistCountElement = document.getElementById("wishlist-count");
  if (!wishlistCountElement) {
    console.error("Error: Could not find wishlist count element on the page.");
    return;
  }

  // Check if the customer is logged in
  if (window.customerId && window.customerId !== "null") {
    console.log(
      "Customer is logged in. Fetching wishlist count from backend for customerId:",
      window.customerId
    );
    const url =
      "https://us-central1-shopify-wishlist-backend.cloudfunctions.net/getWishlistCount";

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ customerId: window.customerId }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Fetched wishlist count from backend:", data);
        wishlistCountElement.textContent = data.count > 0 ? data.count : "";
        wishlistCountElement.style.display = data.count > 0 ? "inline" : "none";
      })
      .catch((error) => {
        console.error("Failed to fetch wishlist count from backend:", error);
      });
  } else {
    // Fallback to local wishlist count
    console.log("Customer is not logged in. Using local wishlist count.");
    wishlistCountElement.textContent = wishlist.length > 0 ? wishlist.length : "";
    wishlistCountElement.style.display = wishlist.length > 0 ? "inline" : "none";
  }
}

// Function to update the wishlist button state
function updateWishlistButtonState(productHandle) {
    console.log("Function called with ", productHandle);
  const buttons = document.querySelectorAll(
    `.add-to-wishlist-button[data-product-handle="${productHandle}"]`
  );
  buttons.forEach((button) => {
    if (wishlist.includes(productHandle)) {
      button.classList.add("active-wishlist");
    } else {
      button.classList.remove("active-wishlist");
    }
  });
}


// Function to update the wishlist button state for logged-in users
function updateWishlistButtonStateLoggedIn(productHandle) {
  const buttons = document.querySelectorAll(
    `.add-to-wishlist-button[data-product-handle="${productHandle}"]`
  );
  buttons.forEach((button) => {
    if (wishlist.includes(productHandle)) {
      button.classList.add("active-wishlist-new");
    } else {
      button.classList.remove("active-wishlist-new");
    }
  });
}


// New Popup
// New Popup

document.addEventListener("DOMContentLoaded", () => {
  const wishlistButtons = document.querySelectorAll(".add-to-wishlist-button");

  wishlistButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.stopPropagation(); // Prevent event bubbling
      
      // Remove any existing popups before creating a new one
      const existingPopup = document.querySelector(".wishlist-popup");
      if (existingPopup) {
        existingPopup.remove();
      }

      // Check if customer is logged in
      const isLoggedIn = window.customerId && window.customerId !== "null";

      // Check if adding to wishlist for logged-in customers
      if (isLoggedIn && button.classList.contains("active-wishlist-new")) {
        // Create a new popup element for logged-in customers
        const wishlistPopupLoggedIn = document.createElement("div");
        wishlistPopupLoggedIn.classList.add("wishlist-popup");
        wishlistPopupLoggedIn.innerHTML = `
       <div class="current-inner-wrapper">
          <div class="wishlist-popup-content">
            <h3>${window.wishlistPopupSettings.loggedInTitle}</h3>
            <span class="seperator-wish"></span>
            <p>${window.wishlistPopupSettings.loggedInText}</p>
            <a href="${window.wishlistPopupSettings.loggedInCTAUrl}"><button class="button wishlist-popup-button">${window.wishlistPopupSettings.loggedInCTA}</button></a>
          </div>
          <button class="close-button">×</button>
        </div>


        `;

        // Insert the popup after the clicked button
        if (window.innerWidth < 767) {
          document.body.appendChild(wishlistPopupLoggedIn);
        } else {
          button.parentNode.insertBefore(wishlistPopupLoggedIn, button.nextSibling);
        }

        // Add event listener to close the popup
        const closePopupButton = wishlistPopupLoggedIn.querySelector(".close-button");
        closePopupButton.addEventListener("click", () => {
          wishlistPopupLoggedIn.remove();
          document.removeEventListener("click", handleClickOutside);
        });

        // Add event listener to close the popup when clicking outside of it
        const handleClickOutside = (event) => {
          if (!wishlistPopupLoggedIn.contains(event.target)) {
            wishlistPopupLoggedIn.remove();
            document.removeEventListener("click", handleClickOutside);
          }
        };
        setTimeout(() => {
          document.addEventListener("click", handleClickOutside);
        }, 0); // Delay to ensure the popup is added to the DOM before attaching the event

        // Optional: Hide the popup after 6 seconds
        setTimeout(() => {
          wishlistPopupLoggedIn.remove();
          document.removeEventListener("click", handleClickOutside);
        }, 6000);
      } else if (!isLoggedIn && button.classList.contains("active-wishlist")) {
        // Create a new popup element for logged-out customers
        const wishlistPopup = document.createElement("div");
        wishlistPopup.classList.add("wishlist-popup");
        wishlistPopup.innerHTML = `
       <div class="current-inner-wrapper">
        <div class="wishlist-popup-content">
          <h3>${window.wishlistPopupSettings.loggedOutTitle}</h3>
          <span class="seperator-wish"></span>
          <p>${window.wishlistPopupSettings.loggedOutText}</p>
          <a href="${window.wishlistPopupSettings.loggedOutCTAUrl}" class="button wishlist-popup-button">${window.wishlistPopupSettings.loggedOutCTA}</a>
        </div>
        <button class="close-button">×</button>
      </div>


        `;

        // Insert the popup after the clicked button
        if (window.innerWidth < 767) {
          document.body.appendChild(wishlistPopup);
        } else {
          button.parentNode.insertBefore(wishlistPopup, button.nextSibling);
        }

        // Add event listener to close the popup
        const closePopupButton = wishlistPopup.querySelector(".close-button");
        closePopupButton.addEventListener("click", () => {
          wishlistPopup.remove();
          document.removeEventListener("click", handleClickOutside);
        });

        // Add event listener to close the popup when clicking outside of it
        const handleClickOutside = (event) => {
          if (!wishlistPopup.contains(event.target)) {
            wishlistPopup.remove();
            document.removeEventListener("click", handleClickOutside);
          }
        };
        setTimeout(() => {
          document.addEventListener("click", handleClickOutside);
        }, 0); // Delay to ensure the popup is added to the DOM before attaching the event

        // Optional: Hide the popup after 6 seconds
        setTimeout(() => {
          document.removeEventListener("click", handleClickOutside);
        }, 6000);
      }
    });
  });
});



